import React, { useEffect, useState } from "react";
// import { useLocation } from "react-router-dom";
// import { useNavigate } from "react-router-dom";
import Profiledropdown from "./ProfileDropdown/profiledropdown";
import $ from "jquery";
import {
  AESEncryption,
  ApiResDecrypt,
  goToClientDashboard,
  headearNameWithPath,
  toggleSidebar,
} from "../CommonMethhods/CommonMethods";
import { Client_Search } from "../Configuration/API_URL";
import LoaderForSearch from "./Common/LoaderForSearch";
import { useLocation, useNavigate } from "react-router-dom";
import { useDebounce } from "./useDebounce";
import axiosInstance from "../CommonMethhods/axiosInstance";

function Header(props) {
  // let navigate = useNavigate();
  const storeToken = localStorage.getItem("ssoToken");

  // let location = useLocation();
  // let pageTitle = location.pathname.replace("/", "").replace("-", " ");

  const [pageTitle, setPageTitle] = useState("");

  const [value, setValue] = useState("");
  const [scroll, setScroll] = useState(false);
  const [searchIcon, setSearchIcon] = useState(true);
  const [error, setError] = useState("");
  const [clientList, setClientList] = useState([]);
  const [clientName, setClientName] = useState("");
  const [clientCode, setClientCode] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [count, setCount] = useState();
  const [searhPartnerShow, setSearchPartnerShow] = useState(true);
  // let UserName;
  // if (props.portal == "RM") UserName = localStorage.getItem("RMName");
  // else UserName = localStorage.getItem("userName");

  const debouncedValue = useDebounce(clientName, 1000);
    useEffect(() => {
      handleClientName(debouncedValue);
    }, [debouncedValue]);

  const navigate = useNavigate();

  const location = useLocation();

  useEffect(() => {
    let urlPathName = location.pathname;
    const headerPath = headearNameWithPath(urlPathName);
    console.log("header path",headerPath)
    setPageTitle(headerPath);
    function handleInvalidToken() {
      if (!localStorage.getItem("ssoToken")) {
        navigate("/");
      }
    }
    window.addEventListener("storage", handleInvalidToken);
    return () => {
      window.removeEventListener("storage", handleInvalidToken);
    };
  }, [location.pathname]);
  if (value) {
    localStorage.setItem("clientSearch", value);
  }

  // function search() {
  //   if (props.handleSearch !== undefined || null) {
  //     props.handleSearchClick(true);
  //   }
  // }

  function checkValidate(clientCode, pan) {
    if (clientCode) {
      window.location.replace("/client-dashboard");
      localStorage.setItem("tabOnboarding","")
      goToClientDashboard(clientCode, pan);
    }
  }

  function mobileSearch() {
    let mobsearch = document.querySelector(".search-box");

    if (searchIcon) {
      mobsearch.classList.add("show");
      setSearchIcon(false);
    } else {
      mobsearch.classList.remove("show");
      setSearchIcon(true);
    }
  }

  async function searchApiDetail(val) {
    $(".write-search.headerSearch").addClass("show-result scroll-table");
    let payloadValue = {
      keyword: val,
      Status: "",
      PageNo: page,
      PageSize: pageSize,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getSearchDetail = await axiosInstance.post(
        Client_Search.Search_URL,
        `"${encPayload}"`
      );
      const res = ApiResDecrypt(getSearchDetail?.data);

      setCount(res.data.TotalCount);
      if (res.message === "Client does not exist.") {
        setClientList([
          { clientname: "Client does not exist.", clientCode: null },
        ]);
      } else {
        if (scroll == true) {
          setClientList((prev) => {
            return [...prev, ...res.data.clients];
          });
        } else {
          setClientList(res.data.clients);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setScrollLoader(false);
    }
  }

  function clientSet(name, code, i) {
    if (name === "Client does not exist.") {
      $(".write-search.headerSearch").addClass("show-result scroll-table");
    } else {
      $(".write-search.headerSearch").removeClass("show-result");
      setClientList([]);
      setClientName(name);
      setClientCode(code);
      checkValidate(code);
      setScrollLoader(false);
    }
  }
  const handleClientName = (data) => {
    setScrollLoader(false);
    if (data) {
      setClientList([]);
      setScroll(false);
      // let result = e.target.value.toUpperCase();
      // setClientName(result);
      if (data?.length > 3) {
        setPage(1);
        setClientList([]);
        setScroll(false);
        searchApiDetail(data);
      }
    } else {
      // alert("1")
      setClientList([]);
      setPage(1);
      setClientName("");
      setScroll(false);
      $(".write-search.headerSearch").removeClass("show-result");

      // searchApiDetail("")
    }
    $(".write-search.headerSearch-li").click(function () {
      $(".write-search.headerSearch").addClass("show-result scroll-table");
    });
  };

  const handleScroll = async () => {
    setScroll(true);
    const a = document.querySelector("#scroll-search");
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight) {
      if (count <= page * pageSize) {
        setScrollLoader(false);
        return;
      }
      setPage((prev) => prev + 1);
      setScrollLoader(true);
      // searchApiDetail(clientName);
    }
  };
  // for pagination end

  useEffect(() => {
    if (page > 1) {
      searchApiDetail(clientName);
    }
  }, [page]);

  useEffect(() => {
    let partner = localStorage.getItem("partnerRole");
    let partnerNew = localStorage?.getItem("partnerRoleNew");
    if (partner || partnerNew) {
      if (partner === "Partner" || partnerNew === "Partner") {
        setSearchPartnerShow(false);
      }
    }
    if(props?.portal=="TELECALLER"){
      document.getElementById("searchicon-remove-tele").style.display = 'none'
    }else{
      // document.getElementById("searchicon-remove-tele").style.display = 'block'
    }
  }, []);

  return (
    <>
      {/* header */}
      <header>
        <div className="container-fluid">
          <div className="row align-items-center">
            {/* header left */}
            <div className="col-md-6 col-6">
              <div className="header-left">
                <div className="menu-icon" onClick={toggleSidebar}>
                  {/* <img src={Menu} alt="" /> */}
                  <span className="icon-horizontal-menu"></span>
                </div>
                <div className="logo-title">{pageTitle}</div>
              </div>
            </div>
            {/* header right */}
            <div className="col-md-6 col-6">
              <div className="header-right">
                {props?.roleLabel && (
                  <span className="hdr-role-badge">Role: {props.roleLabel}</span>
                )}

                {(props?.onBulkUpload || props?.onNewRequest) && (
                  <div className="hdr-action-btns">
                    {props?.onBulkUpload && (
                      <button
                        type="button"
                        className="hdr-outline-btn"
                        onClick={props.onBulkUpload}
                      >
                        Bulk upload
                      </button>
                    )}
                    {props?.onNewRequest && (
                      <button
                        type="button"
                        className="hdr-solid-btn"
                        onClick={props.onNewRequest}
                      >
                        New request
                      </button>
                    )}
                  </div>
                )}

                <div className="searchicon-mobile" id="searchicon-remove-tele">
                  <div
                    id="searchdrop"
                    className={`${
                      searchIcon ? "icon-search-bar" : "icon-close"
                    }`}
                    onClick={(e) => mobileSearch()}
                  ></div>
                </div>
                <div
                  className="search-box"
                  // onMouseDown={handleMouse}
                >
                  <div>
                    <div className="form-group" id="search-mob">
                      {props?.portal == "RM" && searhPartnerShow && (
                        <>
                          <div className="for-position">
                            <input
                              type="text"
                              name="search-text"
                              id="SearchInput"
                              className="input-st"
                              placeholder="Search here..."
                              autoComplete="off"
                              value={clientName}
                              onInput={(e) => {
                                const start = e.target.selectionStart;
                                const end = e.target.selectionEnd;

                                let input = e.target.value.toUpperCase();
                                input = input.replace(/[^a-zA-Z0-9 ]/g, "");
                                        input = input.replace(/\s{2,}/g, " "); 
                                        input = input.replace(/^\s+/, ""); 

                                if (input.length > 100) input = input.slice(0, 100);
                                e.target.value = input;
                                e.target.setSelectionRange(start, end);
                              }}
                              onChange={(e) => {
                                setClientName(e?.target?.value.toUpperCase());
                                setError("");
                                // handleClientName(e);
                              }}
                            />

                            <ul
                              className="write-search headerSearch border-0"
                              id="scroll-search"
                              onScroll={handleScroll}
                            >
                              {clientList.map((item, i) => (
                                <li
                                  key={i}
                                  onClick={() =>
                                    clientSet(
                                      item.clientname,
                                      item.clientCode,
                                      i
                                    )
                                  }
                                >
                                  <div> {item.clientname}</div>
                                  <div> {item.clientCode}</div>
                                </li>
                              ))}
                              {scrollLoader && (
                                <div className="loader-center">
                                  <LoaderForSearch />
                                </div>
                              )}
                            </ul>
                            <span className="search-error">{error}</span>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <Profiledropdown portal={props.portal} showUserId={props?.showUserId} />
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;

